import type { FC } from 'react';

const COMPANY_NAME = 'Peesential';
const MERKNU_URL = 'https://merknu.nl';

export const AppFooter: FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-surface-50">
            <div className="mt-0 border-t border-surface-300 pt-6 pb-4 text-center text-xs text-surface-900">
                <small
                    className="block"
                    itemScope
                    itemType="https://schema.org/Organization"
                >
                    <span itemProp="name" className="sr-only">Merknu</span>
                    <link itemProp="url" href={MERKNU_URL} />
                    Website door{' '}
                    <a
                        href={MERKNU_URL}
                        rel="noopener"
                        target="_blank"
                        title="Website laten maken door Merknu"
                        aria-label="Website gemaakt door Merknu — webdevelopment voor lokale bedrijven"
                        className="font-regular underline-offset-2 hover:underline hover:text-primary-600 transition-colors"
                    >
                        Merknu
                    </a>
                </small>
                <div className="mt-1">
                    © {currentYear} {COMPANY_NAME}. Alle rechten voorbehouden.
                </div>
            </div>
        </footer>
    );
};
